import { Optional } from '../../../../shared-kernel';
import {
  CountryName,
  ProductVendor
} from '../../../../store/products/types';

export const combineVendorAndCountry = (
  vendor: Optional<ProductVendor>,
  country: CountryName
) => {
  if (vendor === null) {
    return null;
  }

  if (!country) {
    return { ...vendor };
  }

  return { ...vendor, name: vendor.name + ', ' + country };
};
